// Embedded-in-mobile-app display mode (entered via the app auth bridge: ?app=1).
const KEY = "rgm_app_mode";
export const APP_ALLOWED_PATHS = ["/affiliate", "/referrals", "/creator-hub"];
const CHECKOUT_RE = /\/(beats\/[^/]+\/checkout|magazine\/checkout|coins\/checkout|memberships\/checkout|singles\/[^/]+\/checkout|clubs\/[^/]+\/checkout|users\/me\/stripe-portal)\/?$/;

export const initAppMode = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("app") === "1") sessionStorage.setItem(KEY, "1");
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const isAppMode = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
};

export const isAppAllowedPath = (path) => APP_ALLOWED_PATHS.includes((path || "").replace(/\/+$/, "") || "/");

export const isCheckoutRequest = (url) => CHECKOUT_RE.test((url || "").split("?")[0]);

export const postToApp = (msg) => {
  try { window.ReactNativeWebView?.postMessage(JSON.stringify(msg)); } catch { /* not in app */ }
};
